<template>
    <div id="todo-imprimbook">
        <h2>LOREM IPSUM</h2>
        <p>Puzzle, etc. a renvoyer sur le form groupe-santerre</p>
    </div>
</template>

<script>
export default {
    name: "TodoImprimBook",
};
</script>

<style scoped>

</style>